var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "container" },
    [
      _c(
        "div",
        { staticClass: "breadcrumb" },
        [
          _c(
            "el-breadcrumb",
            { attrs: { separator: "" } },
            [
              _c("el-breadcrumb-item", [
                _c("div", { staticClass: "div1" }, [_vm._v("供应商管理")]),
              ]),
              _c(
                "el-breadcrumb-item",
                { attrs: { to: { path: "/add_supplier" } } },
                [_c("div", { staticClass: "div2" }, [_vm._v("新增供应商")])]
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c("el-collapse-transition", [
        _c(
          "div",
          {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: !_vm.show3,
                expression: "!show3",
              },
            ],
            staticClass: "query",
          },
          [
            _c("div", { staticClass: "header" }, [
              _c("span", [_vm._v("数据查询")]),
              _c(
                "p",
                {
                  on: {
                    click: function ($event) {
                      _vm.show3 = true
                    },
                  },
                },
                [_vm._v("收起")]
              ),
            ]),
            _c(
              "div",
              { staticClass: "polling" },
              [
                _c(
                  "el-form",
                  {
                    ref: "form",
                    attrs: {
                      inline: true,
                      model: _vm.queryForm,
                      "label-width": "",
                      size: "mini",
                    },
                  },
                  [
                    _c(
                      "el-form-item",
                      { attrs: { label: "供应商" } },
                      [
                        _c("el-input", {
                          attrs: { placeholder: "请输入供应商姓名/电话" },
                          model: {
                            value: _vm.queryForm.info,
                            callback: function ($$v) {
                              _vm.$set(_vm.queryForm, "info", $$v)
                            },
                            expression: "queryForm.info",
                          },
                        }),
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      { attrs: { label: "商品名称" } },
                      [
                        _c("el-input", {
                          attrs: { placeholder: "请输入商品名称" },
                          model: {
                            value: _vm.queryForm.goodName,
                            callback: function ($$v) {
                              _vm.$set(_vm.queryForm, "goodName", $$v)
                            },
                            expression: "queryForm.goodName",
                          },
                        }),
                      ],
                      1
                    ),
                    _c("div", { staticClass: "selectDate" }, [
                      _c("span", [_vm._v("创建时间")]),
                      _c(
                        "div",
                        { staticClass: "picker" },
                        [
                          _c("el-date-picker", {
                            attrs: {
                              type: "daterange",
                              "unlink-panels": "",
                              "range-separator": "至",
                              "start-placeholder": "开始日期",
                              "end-placeholder": "结束日期",
                              format: "yyyy-MM-dd",
                              "value-format": "yyyy-MM-dd",
                            },
                            model: {
                              value: _vm.queryForm.date,
                              callback: function ($$v) {
                                _vm.$set(_vm.queryForm, "date", $$v)
                              },
                              expression: "queryForm.date",
                            },
                          }),
                        ],
                        1
                      ),
                    ]),
                    _c(
                      "el-form-item",
                      { attrs: { label: "创建人" } },
                      [
                        _c(
                          "el-select",
                          {
                            attrs: {
                              placeholder: "请选择创建人",
                              clearable: "",
                              "default-first-option": "",
                            },
                            model: {
                              value: _vm.queryForm.founder,
                              callback: function ($$v) {
                                _vm.$set(_vm.queryForm, "founder", $$v)
                              },
                              expression: "queryForm.founder",
                            },
                          },
                          _vm._l(_vm.createList, function (items) {
                            return _c("el-option", {
                              key: items.label,
                              attrs: { label: items.value, value: items.label },
                            })
                          }),
                          1
                        ),
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      { attrs: { label: "供应地址" } },
                      [
                        _c("el-input", {
                          attrs: { placeholder: "请输入供应商地址" },
                          model: {
                            value: _vm.queryForm.address,
                            callback: function ($$v) {
                              _vm.$set(_vm.queryForm, "address", $$v)
                            },
                            expression: "queryForm.address",
                          },
                        }),
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      { attrs: { label: "选择品牌" } },
                      [
                        _c(
                          "el-select",
                          {
                            attrs: {
                              placeholder: "请选择产品品牌",
                              clearable: "",
                              "default-first-option": "",
                            },
                            model: {
                              value: _vm.queryForm.brand,
                              callback: function ($$v) {
                                _vm.$set(_vm.queryForm, "brand", $$v)
                              },
                              expression: "queryForm.brand",
                            },
                          },
                          _vm._l(_vm.brandselect, function (items) {
                            return _c("el-option", {
                              key: items.id,
                              attrs: { label: items.name, value: items.id },
                            })
                          }),
                          1
                        ),
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      { attrs: { label: "商品类型" } },
                      [
                        _c(
                          "el-select",
                          {
                            attrs: {
                              placeholder: "请选择商品类型",
                              clearable: "",
                              "default-first-option": "",
                            },
                            on: { change: _vm.onChange },
                            model: {
                              value: _vm.queryForm.category,
                              callback: function ($$v) {
                                _vm.$set(_vm.queryForm, "category", $$v)
                              },
                              expression: "queryForm.category",
                            },
                          },
                          [
                            _c(
                              "el-option",
                              { attrs: { value: 1, label: "商品" } },
                              [_vm._v("商品")]
                            ),
                            _c(
                              "el-option",
                              { attrs: { value: 2, label: "赠品" } },
                              [_vm._v("赠品")]
                            ),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      [
                        _c(
                          "el-button",
                          {
                            attrs: { type: "primary", size: "mini" },
                            on: {
                              click: function ($event) {
                                return _vm.searchEvent()
                              },
                              keyup: function ($event) {
                                if (
                                  !$event.type.indexOf("key") &&
                                  _vm._k(
                                    $event.keyCode,
                                    "enter",
                                    13,
                                    $event.key,
                                    "Enter"
                                  )
                                )
                                  return null
                                return _vm.searchEvent.apply(null, arguments)
                              },
                            },
                          },
                          [_vm._v("搜索")]
                        ),
                        _c(
                          "el-button",
                          {
                            attrs: { plain: "", size: "mini" },
                            on: { click: _vm.reset },
                          },
                          [_vm._v("重置")]
                        ),
                      ],
                      1
                    ),
                  ],
                  1
                ),
              ],
              1
            ),
          ]
        ),
      ]),
      _c("div", { staticClass: "btnBox" }, [
        _c(
          "div",
          { staticClass: "btns" },
          [
            _vm.parArray.indexOf("addsupplierCode") != -1
              ? _c(
                  "el-button",
                  {
                    attrs: { type: "primary", size: "mini" },
                    on: {
                      click: function ($event) {
                        _vm.addFalse = true
                      },
                    },
                  },
                  [
                    _c(
                      "span",
                      {
                        staticStyle: {
                          display: "flex",
                          "align-items": "center",
                        },
                      },
                      [
                        _c("img", {
                          staticStyle: {
                            width: "14px",
                            height: "14px",
                            "margin-right": "5px",
                          },
                          attrs: {
                            src: require("../../../assets/icon/icon_add.png"),
                          },
                        }),
                        _vm._v("添 加 "),
                      ]
                    ),
                  ]
                )
              : _vm._e(),
            _c(
              "el-button",
              {
                attrs: { type: "primary", size: "mini" },
                on: { click: _vm.exports },
              },
              [
                _c(
                  "span",
                  { staticStyle: { display: "flex", "align-items": "center" } },
                  [
                    _c("img", {
                      staticStyle: {
                        width: "14px",
                        height: "14px",
                        "margin-right": "5px",
                      },
                      attrs: {
                        src: require("../../../assets/icon/icon_daochu.png"),
                      },
                    }),
                    _vm._v("导 出 "),
                  ]
                ),
              ]
            ),
            _c(
              "el-button",
              {
                attrs: { type: "primary", size: "mini" },
                on: { click: _vm.tpPrintJS },
              },
              [
                _c(
                  "span",
                  { staticStyle: { display: "flex", "align-items": "center" } },
                  [
                    _c("img", {
                      staticStyle: {
                        width: "14px",
                        height: "14px",
                        "margin-right": "5px",
                      },
                      attrs: { src: require("../../../assets/icon/dayin.png") },
                    }),
                    _vm._v("打 印 "),
                  ]
                ),
              ]
            ),
            _vm.parArray.indexOf("delectSupplierCode") != -1
              ? _c(
                  "el-button",
                  {
                    attrs: { type: "primary", size: "mini" },
                    on: {
                      click: function ($event) {
                        return _vm.deleteImg(0)
                      },
                    },
                  },
                  [
                    _c(
                      "span",
                      {
                        staticStyle: {
                          display: "flex",
                          "align-items": "center",
                        },
                      },
                      [
                        _c("img", {
                          staticStyle: {
                            width: "14px",
                            height: "14px",
                            "margin-right": "5px",
                          },
                          attrs: {
                            src: require("../../../assets/icon/icon_shanchu.png"),
                          },
                        }),
                        _vm._v("删 除 "),
                      ]
                    ),
                  ]
                )
              : _vm._e(),
          ],
          1
        ),
        _c(
          "p",
          {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.show3,
                expression: "show3",
              },
            ],
            staticClass: "shows",
            on: {
              click: function ($event) {
                _vm.show3 = false
              },
            },
          },
          [_vm._v("搜索展开")]
        ),
      ]),
      _c(
        "div",
        { staticClass: "table" },
        [
          _c(
            "el-table",
            {
              staticStyle: { width: "100%" },
              attrs: { data: _vm.tableData.list },
              on: { "selection-change": _vm.handleSelectionChange },
            },
            [
              _c("el-table-column", {
                attrs: { type: "selection", width: "55" },
              }),
              _c("el-table-column", {
                attrs: { type: "index", label: "序号", width: "50px" },
              }),
              _c("el-table-column", {
                attrs: {
                  prop: "supplierId",
                  "min-width": "100",
                  label: "供应商编号",
                },
              }),
              _c("el-table-column", {
                attrs: { label: "创建时间", "min-width": "120px" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _vm._v(_vm._s(_vm.$moment(scope.row.createdTime))),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: { prop: "createdName", label: "创建人" },
              }),
              _c("el-table-column", {
                attrs: {
                  prop: "supplierName",
                  label: "供应商姓名",
                  "min-width": "95px",
                },
              }),
              _c("el-table-column", {
                attrs: { prop: "supplierContactPerson", label: "联系人" },
              }),
              _c("el-table-column", {
                attrs: {
                  prop: "supplierPhone",
                  "min-width": "110px",
                  label: "电话",
                },
              }),
              _c("el-table-column", {
                attrs: {
                  prop: "supplierAddress",
                  "min-width": "100px",
                  "show-overflow-tooltip": "",
                  label: "地址",
                },
              }),
              _c("el-table-column", {
                attrs: {
                  prop: "prodName",
                  "min-width": "200",
                  "show-overflow-tooltip": "",
                  label: "商品名称",
                },
              }),
              _c("el-table-column", {
                attrs: { prop: "prodType", label: "商品类型" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _vm._v(
                          " " +
                            _vm._s(scope.row.prodType == 1 ? "商品" : "赠品") +
                            " "
                        ),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: { prop: "prodPrice", label: "采购单价" },
              }),
              _c("el-table-column", {
                attrs: { prop: "prodSpecificationName", label: "商品规格" },
              }),
              _c("el-table-column", {
                attrs: { label: "图片", "min-width": "100px" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c(
                          "el-tooltip",
                          {
                            staticClass: "item",
                            attrs: {
                              effect: "dark",
                              content:
                                scope.row.supplierImage &&
                                scope.row.supplierImage.length > 0
                                  ? "查看更多"
                                  : "没有",
                              placement: "top",
                            },
                          },
                          [
                            _c("el-image", {
                              staticStyle: {
                                width: "40px",
                                height: "40px",
                                cursor: "pointer",
                              },
                              attrs: {
                                src:
                                  _vm.ImgHttps +
                                  _vm.getImageBySrc(scope.row.supplierImage),
                              },
                              on: {
                                click: function ($event) {
                                  ;(_vm.imageSrc = scope.row.supplierImage),
                                    (_vm.dialogVisible = true)
                                },
                              },
                            }),
                          ],
                          1
                        ),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: { label: "商品材质" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        scope.row.prodMaterial
                          ? _c(
                              "div",
                              {
                                staticStyle: {
                                  cursor: "pointer",
                                  width: "50px",
                                  height: "20px",
                                  overflow: "hidden",
                                },
                                on: {
                                  click: function ($event) {
                                    return _vm.moreProdMaterial(
                                      scope.row.prodMaterial
                                    )
                                  },
                                },
                              },
                              [
                                _vm._v(
                                  " " + _vm._s(scope.row.prodMaterial) + " "
                                ),
                              ]
                            )
                          : _vm._e(),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: { fixed: "right", label: "操作" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _vm.parArray.indexOf("startUsingCode") != -1
                          ? _c(
                              "div",
                              {
                                staticStyle: {
                                  color: "#4168e7",
                                  cursor: "pointer",
                                },
                                on: {
                                  click: function ($event) {
                                    return _vm.startUsing(scope.row.id)
                                  },
                                },
                              },
                              [_vm._v(" 启用 ")]
                            )
                          : _vm._e(),
                      ]
                    },
                  },
                ]),
              }),
            ],
            1
          ),
        ],
        1
      ),
      _c("div", { staticStyle: { height: "50px" } }),
      _vm.tableData.totalNum >= 10
        ? _c("div", { staticClass: "page" }, [
            _c(
              "div",
              { staticClass: "block" },
              [
                _c("el-pagination", {
                  attrs: {
                    "current-page": _vm.tableData.pageNo,
                    "page-sizes": [10, 20, 50, 100, 200],
                    "page-size": _vm.tableData.pageSize,
                    layout: "total, sizes, prev, pager, next, jumper",
                    total: _vm.tableData.totalNum,
                    "prev-text": "上一页",
                    "next-text": "下一页",
                  },
                  on: {
                    "size-change": _vm.handleSizeChange,
                    "current-change": _vm.handleCurrentChange,
                  },
                }),
              ],
              1
            ),
          ])
        : _vm._e(),
      _c(
        "el-dialog",
        {
          attrs: {
            visible: _vm.addFalse,
            "append-to-body": true,
            title: "新增供应商",
          },
          on: {
            "update:visible": function ($event) {
              _vm.addFalse = $event
            },
          },
        },
        [
          _c(
            "div",
            { staticClass: "supplier" },
            [
              _c(
                "el-form",
                { attrs: { "label-width": "80px", "label-position": "right" } },
                [
                  _c(
                    "el-form-item",
                    { attrs: { label: "供应商" } },
                    [
                      _c(
                        "el-select",
                        {
                          attrs: {
                            placeholder: "请选择供应商",
                            clearable: "",
                            remote: "",
                            "allow-create": "",
                            "remote-method": _vm.remoteSMethod,
                            filterable: "",
                            "default-first-option": "",
                          },
                          on: { change: _vm.supplierSelect },
                          model: {
                            value: _vm.formLabel.supplier,
                            callback: function ($$v) {
                              _vm.$set(_vm.formLabel, "supplier", $$v)
                            },
                            expression: "formLabel.supplier",
                          },
                        },
                        _vm._l(_vm.supplierNames, function (item, index) {
                          return _c("el-option", {
                            key: index,
                            attrs: { value: item, label: item },
                          })
                        }),
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: "联系人" } },
                    [
                      _c("el-input", {
                        attrs: { maxlength: 10 },
                        model: {
                          value: _vm.formLabel.linkName,
                          callback: function ($$v) {
                            _vm.$set(_vm.formLabel, "linkName", $$v)
                          },
                          expression: "formLabel.linkName",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: "电话" } },
                    [
                      _c("el-input", {
                        attrs: { maxlength: 52 },
                        model: {
                          value: _vm.formLabel.phone,
                          callback: function ($$v) {
                            _vm.$set(_vm.formLabel, "phone", $$v)
                          },
                          expression: "formLabel.phone",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: "地址" } },
                    [
                      _c("el-input", {
                        attrs: { maxlength: 32 },
                        model: {
                          value: _vm.formLabel.address,
                          callback: function ($$v) {
                            _vm.$set(_vm.formLabel, "address", $$v)
                          },
                          expression: "formLabel.address",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: "商品类型" } },
                    [
                      _c(
                        "el-select",
                        {
                          attrs: {
                            placeholder: "请选择商品类型",
                            clearable: "",
                            "default-first-option": "",
                          },
                          on: { change: _vm.onChange },
                          model: {
                            value: _vm.formLabel.type,
                            callback: function ($$v) {
                              _vm.$set(_vm.formLabel, "type", $$v)
                            },
                            expression: "formLabel.type",
                          },
                        },
                        [
                          _c(
                            "el-option",
                            { attrs: { value: 1, label: "商品" } },
                            [_vm._v("商品")]
                          ),
                          _c(
                            "el-option",
                            { attrs: { value: 2, label: "赠品" } },
                            [_vm._v("赠品")]
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: "商品名称" } },
                    [
                      _c(
                        "el-select",
                        {
                          attrs: {
                            disabled:
                              _vm.formLabel.type &&
                              _vm.formLabel.type.length == 0,
                            placeholder: "请选择商品名称",
                            clearable: "",
                            remote: "",
                            "remote-method": _vm.remoteMethod,
                            filterable: "",
                            "default-first-option": "",
                          },
                          on: { change: _vm.goodNameSelect },
                          model: {
                            value: _vm.formLabel.goodName,
                            callback: function ($$v) {
                              _vm.$set(_vm.formLabel, "goodName", $$v)
                            },
                            expression: "formLabel.goodName",
                          },
                        },
                        _vm._l(_vm.goodNames, function (item, index) {
                          return _c("el-option", {
                            key: index,
                            attrs: { value: item, label: item },
                          })
                        }),
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: "商品品牌" } },
                    [
                      _c("el-input", {
                        attrs: { disabled: "" },
                        model: {
                          value: _vm.formLabel.brand,
                          callback: function ($$v) {
                            _vm.$set(_vm.formLabel, "brand", $$v)
                          },
                          expression: "formLabel.brand",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: "商品规格" } },
                    [
                      _c("el-input", {
                        attrs: { disabled: "" },
                        model: {
                          value: _vm.formLabel.guige,
                          callback: function ($$v) {
                            _vm.$set(_vm.formLabel, "guige", $$v)
                          },
                          expression: "formLabel.guige",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: "采购单价" } },
                    [
                      _c("el-input-number", {
                        staticStyle: { width: "100%" },
                        attrs: {
                          max: 9999999999,
                          controls: false,
                          type: "number",
                        },
                        model: {
                          value: _vm.formLabel.price,
                          callback: function ($$v) {
                            _vm.$set(_vm.formLabel, "price", $$v)
                          },
                          expression: "formLabel.price",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: "商品材质" } },
                    [
                      _c("el-input", {
                        attrs: { maxlength: 64 },
                        model: {
                          value: _vm.formLabel.material,
                          callback: function ($$v) {
                            _vm.$set(_vm.formLabel, "material", $$v)
                          },
                          expression: "formLabel.material",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: "上传图片" } },
                    [
                      _c(
                        "el-upload",
                        {
                          ref: "upload",
                          staticClass: "video",
                          attrs: {
                            action: "#",
                            multiple: "",
                            limit: 10,
                            "on-exceed": _vm.test,
                            "before-upload": _vm.beforeUploadImg,
                            "http-request": _vm.imgUpload,
                            "file-list": _vm.fileListImg,
                            "show-file-list": false,
                          },
                        },
                        [
                          _c("i", {
                            staticClass: "el-icon-upload2",
                            staticStyle: { "font-size": "25px" },
                          }),
                        ]
                      ),
                      _c(
                        "div",
                        _vm._l(_vm.fileListImg, function (item, index) {
                          return _c(
                            "div",
                            {
                              key: index,
                              staticStyle: {
                                border: "1px solid #666",
                                display: "inline-block",
                                padding: "2px",
                                "margin-right": "5px",
                                position: "relative",
                              },
                            },
                            [
                              _c("el-image", {
                                staticStyle: { width: "40px", height: "40px" },
                                attrs: { src: _vm.ImgHttps + item.img },
                              }),
                              _c("i", {
                                staticClass: "el-icon-error",
                                staticStyle: {
                                  position: "absolute",
                                  top: "-4px",
                                  right: "-6px",
                                  background: "#fff",
                                  cursor: "pointer",
                                },
                                on: {
                                  click: function ($event) {
                                    return _vm.deleteImg(1, index)
                                  },
                                },
                              }),
                            ],
                            1
                          )
                        }),
                        0
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "div",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c(
                "el-button",
                {
                  attrs: { size: "mini", type: "primary" },
                  on: { click: _vm.add },
                },
                [_vm._v("确定 ")]
              ),
              _c(
                "el-button",
                {
                  attrs: { size: "mini" },
                  on: {
                    click: function ($event) {
                      _vm.addFalse = false
                    },
                  },
                },
                [_vm._v("取 消")]
              ),
            ],
            1
          ),
        ]
      ),
      _c(
        "el-dialog",
        {
          attrs: {
            title: "图片",
            visible: _vm.dialogVisible,
            "append-to-body": true,
            width: "50%",
          },
          on: {
            "update:visible": function ($event) {
              _vm.dialogVisible = $event
            },
          },
        },
        [
          _vm.imageSrc
            ? _c(
                "div",
                { staticStyle: { display: "flex", "flex-wrap": "wrap" } },
                _vm._l(_vm.imageSrc.split(","), function (item) {
                  return _c("el-image", {
                    key: item,
                    staticStyle: {
                      "margin-right": "10px",
                      width: "100px",
                      height: "100px",
                    },
                    attrs: { src: _vm.ImgHttps + item },
                  })
                }),
                1
              )
            : _vm._e(),
          _c(
            "span",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c(
                "el-button",
                {
                  on: {
                    click: function ($event) {
                      _vm.dialogVisible = false
                    },
                  },
                },
                [_vm._v("关闭")]
              ),
            ],
            1
          ),
        ]
      ),
      _c(
        "el-dialog",
        {
          attrs: {
            visible: _vm.isMoreProdMaterial,
            "append-to-body": true,
            title: "材质",
          },
          on: {
            "update:visible": function ($event) {
              _vm.isMoreProdMaterial = $event
            },
          },
        },
        [
          _c(
            "div",
            { staticStyle: { display: "flex" } },
            [
              _c("div", { staticStyle: { "min-width": "80px" } }, [
                _vm._v("材质详情:"),
              ]),
              _c("el-input", {
                attrs: {
                  type: "textarea",
                  rows: 2,
                  placeholder: "请输入内容",
                  value: _vm.moreProdMaterialText,
                },
              }),
            ],
            1
          ),
        ]
      ),
      _c("vue-easy-print", { ref: "easyPrint" }, [
        _c(
          "div",
          { staticStyle: { display: "flex", "justify-content": "center" } },
          [_vm._v("广东九航贸易有限公司")]
        ),
        _c(
          "div",
          { staticStyle: { display: "flex", "justify-content": "center" } },
          [_vm._v("供应商信息")]
        ),
        _c(
          "table",
          {
            staticStyle: { "text-align": "center" },
            attrs: { border: "1", cellpadding: "0", cellspacing: "0" },
          },
          [
            _c("tr", [
              _c("th", { attrs: { width: "5%" } }, [_vm._v("序号")]),
              _c("th", { attrs: { width: "5%" } }, [_vm._v("创建时间")]),
              _c("th", { attrs: { width: "7%" } }, [_vm._v("创建人姓名")]),
              _c("th", { attrs: { width: "7%" } }, [_vm._v("供应商姓名")]),
              _c("th", { attrs: { width: "5%" } }, [_vm._v("联系人")]),
              _c("th", { attrs: { width: "5%" } }, [_vm._v("电话")]),
              _c("th", { attrs: { width: "5%" } }, [_vm._v("地址")]),
              _c("th", { attrs: { width: "5%" } }, [_vm._v("商品类型")]),
              _c("th", { attrs: { width: "5%" } }, [_vm._v("商品名称")]),
              _c("th", { attrs: { width: "5%" } }, [_vm._v("商品品牌")]),
              _c("th", { attrs: { width: "5%" } }, [_vm._v("商品规格")]),
              _c("th", { attrs: { width: "5%" } }, [_vm._v("商品单价")]),
              _c("th", { attrs: { width: "5%" } }, [_vm._v("商品材质")]),
            ]),
            _vm._l(_vm.multipleSelection, function (row, index) {
              return _c("tr", { key: index }, [
                _c("td", [_vm._v(_vm._s(index))]),
                _c("td", [_vm._v(_vm._s(_vm.$moment(row.createdTime)))]),
                _c("td", [_vm._v(_vm._s(row.createdName))]),
                _c("td", [_vm._v(_vm._s(row.supplierName))]),
                _c("td", [_vm._v(_vm._s(row.supplierContactPerson))]),
                _c("td", [_vm._v(_vm._s(row.supplierPhone))]),
                _c("td", [_vm._v(_vm._s(row.supplierAddress))]),
                _c("td", [_vm._v(_vm._s(row.prodType == 1 ? "商品" : "赠品"))]),
                _c("td", [_vm._v(_vm._s(row.prodName))]),
                _c("td", [_vm._v(_vm._s(row.prodBrandName))]),
                _c("td", [_vm._v(_vm._s(row.prodSpecificationName))]),
                _c("td", [_vm._v(_vm._s(row.prodPrice))]),
                _c("td", [_vm._v(_vm._s(row.prodMaterial))]),
              ])
            }),
          ],
          2
        ),
      ]),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }